import { render, staticRenderFns } from "./PhotosUploadList.vue?vue&type=template&id=1afd93ed"
import script from "./PhotosUploadList.vue?vue&type=script&lang=js"
export * from "./PhotosUploadList.vue?vue&type=script&lang=js"
import style0 from "./PhotosUploadList.vue?vue&type=style&index=0&id=1afd93ed&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports